import { configureStore } from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';
import { createReduxHistoryContext } from 'redux-first-history';
import { promiseMiddleware, localStorageMiddleware } from './middleware';
import appReducer from './reducer';

export const browserHistory = createBrowserHistory();

const { routerMiddleware, routerReducer, createReduxHistory } =
    createReduxHistoryContext({ history: browserHistory });

const rootReducer = (state, action) => {
  const { router, ...appState } = state ?? {};
  const nextRouter = routerReducer(router, action);
  const nextApp = appReducer(appState, action);
  return { ...nextApp, router: nextRouter };
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefault) =>
      getDefault({ serializableCheck: false }).concat(
          routerMiddleware,
          promiseMiddleware,
          localStorageMiddleware
      ),
  devTools: process.env.NODE_ENV !== 'production',
});

export const history = createReduxHistory(store);
